const parseEnvFlag = (value, defaultValue) => {
  if (value === undefined || value === null || value === '') return defaultValue;
  const normalized = String(value).trim().toLowerCase();
  if (['true', '1', 'yes', 'on'].includes(normalized)) return true;
  if (['false', '0', 'no', 'off'].includes(normalized)) return false;
  return defaultValue;
};

/** Default false — show "Coming Soon" until REACT_APP_EVENT_BOOKING_ENABLED=true at build time. */
export const isEventBookingEnabled = () =>
  parseEnvFlag(process.env.REACT_APP_EVENT_BOOKING_ENABLED, false);

export const EVENT_CONTACT_CTA_LABEL = 'Contact us to book';
export const EVENT_RAZORPAY_CTA_LABEL = 'Book Now';

/** Per-event Razorpay Payment Page URLs (used when API fields are not set yet). */
const RAZORPAY_BOOKING_URL_OVERRIDES = {
  e_65757e92: 'https://pages.razorpay.com/pl_T2FxtPGbUddXwb/view',
};

export function getRazorpayEmbedConfig(event) {
  if (!event) return null;

  const eventId = event.eventId || event.id;
  const fromApi = event.razorpayEmbed || null;
  const embedUrl =
    event.razorpayEmbedUrl ||
    fromApi?.url ||
    event.razorpayPageUrl ||
    (eventId && RAZORPAY_BOOKING_URL_OVERRIDES[eventId]) ||
    null;

  if (!embedUrl) return null;

  return { url: embedUrl };
}

export function isRazorpayEmbedEvent(event) {
  return getRazorpayEmbedConfig(event) !== null;
}

/** Open Razorpay Payment Page for events configured with a booking URL. */
export function openRazorpayBooking(event) {
  const config = getRazorpayEmbedConfig(event);
  if (!config?.url || typeof window === 'undefined') return false;
  window.location.href = config.url;
  return true;
}

/** Coupon / on-demand events (e.g. swimming, sailing) — book via contact, not checkout. */
export function isContactToBookEvent(event) {
  if (!event) return false;
  if (isRazorpayEmbedEvent(event)) return false;
  if (event.bookingMode === 'razorpay') return false;
  if (event.bookingMode === 'contact') return true;

  const tags = Array.isArray(event.tags)
    ? event.tags.map((t) => String(t).toLowerCase())
    : [];
  if (tags.includes('coupon') || tags.includes('on-demand')) return true;

  const hay = `${event.title || ''} ${event.description || ''}`.toLowerCase();
  if (/\bsailing\b/.test(hay)) return true;
  if (/\bswimming\b/.test(hay) && /\bcoupon\b/.test(hay)) return true;

  return false;
}

export function isEventCtaInteractive(event) {
  return isEventBookingEnabled() || isContactToBookEvent(event) || isRazorpayEmbedEvent(event);
}

export function eventTicketsCtaLabel(event = null) {
  if (isRazorpayEmbedEvent(event)) return EVENT_RAZORPAY_CTA_LABEL;
  if (isContactToBookEvent(event)) return EVENT_CONTACT_CTA_LABEL;
  return isEventBookingEnabled() ? 'Book Tickets' : 'Coming Soon';
}

/** Navigate to contact (coupon/on-demand) or return false so caller opens ticket flow. */
export function navigateEventContactBooking(navigate, event) {
  if (!isContactToBookEvent(event) || !navigate) return false;
  const title = event.title || event.name || 'this event';
  navigate('/contact', {
    state: {
      contactPrefill: {
        subject: 'booking',
        message: `Hi, I would like to book for ${title}. Please share availability and next steps.`,
      },
    },
  });
  return true;
}
